var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStar = function SvgStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.052 1.831c.305-.91 1.592-.91 1.896 0l1.806 5.391a1 1 0 0 0 .939.683l5.685.05c.96.01 1.357 1.234.586 1.805l-4.57 3.383a1 1 0 0 0-.358 1.104l1.708 5.422c.288.915-.753 1.672-1.534 1.115l-4.63-3.3a1 1 0 0 0-1.16 0l-4.63 3.3c-.781.557-1.822-.2-1.534-1.115l1.708-5.422a1 1 0 0 0-.359-1.104L2.036 9.76c-.771-.571-.373-1.795.586-1.804l5.685-.051a1 1 0 0 0 .94-.683z"
  })));
};
export default SvgStar;